'use strict';
var urlJoin = require('url-join');

var checkParams = function(params, requiredParams) {
  var errorString, i;

  for(i = 0; i < requiredParams.length; i++) {
    if(! params[requiredParams[i]]) {
      errorString = 'Params must have a ' + requiredParams[i] + ' property';
      throw new Error(errorString);
    }
  }
};

var paymentURLs = {
  regular: function(productsObject) {
    productsObject.products = productsObject.products.toString();
    var searchParams = new URLSearchParams(productsObject);

    return urlJoin('initiate-payment/', `?${searchParams.toString()}`);
  },

  whitelabel: function(params) {
    checkParams(params, ['url', 'userId', 'partner']);

    const searchParams = new URLSearchParams({
      u: params.userId,
      p: params.partner.toUpperCase()
    });

    return urlJoin(params.url, `?${searchParams.toString()}`);
  },

  whitelabelAddon: function(params) {
    checkParams(params, [
      'url',
      'userId',
      'partner',
      'action',
      'product'
    ]);

    const queryObj = {
      u: params.userId,
      p: params.partner.toUpperCase(),
      action: params.action,
      product: params.product
    };

    if(params.campaignID) {
      queryObj.campaignID = params.campaignID;
    }

    const searchParams = new URLSearchParams(queryObj);

    return urlJoin(params.url, `?${searchParams.toString()}`);
  }
};

module.exports = paymentURLs;
